import { useEffect, useReducer } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { Dispatch, RootState } from '@stores'
import { TPayFormState } from '@stores/types/*'

import { commonApplicationClient } from '../../../api/clients/common-application-client'
import { shopApplicationClient } from '../../../api/clients/shop-application-client'
import { useInit } from '../../../hooks/useInit'
import { payFormService, personalDataService } from '../../../service/payform'
import {
  applicationReducer,
  ApplicationReducerActions,
  TApplicationState,
} from '../../../stores/reducers/ApplicationReducer'
import { EShop } from '../../../stores/types/EShop'
import { Outlet } from '../../common/Outlet'

interface StateProps {
  payForm: TPayFormState
}

interface PersonalDataReducerAction {
  userId: string
  paymentGatewayId: string
}

interface PersonalDataState {
  fetched: boolean
}

const personalDataReducer = (
  state: PersonalDataState,
  action: PersonalDataReducerAction,
) => {
  if (!state.fetched) {
    commonApplicationClient
      .personalData(action.userId, action.paymentGatewayId)
      .then((res) => personalDataService.init(res))
    return { fetched: true }
  }
  return state
}

const ShopWrapperPage = (props: StateProps) => {
  const initialApplication: TApplicationState = { applicationId: '' }
  const initialShop: TShopState = { fetched: false }
  const initialPersonalData = { fetched: false }
  const applicationId = useParams().applicationId

  const [, applicationDispatch] = useReducer(
    applicationReducer,
    initialApplication,
  )

  const [, personalDataDispatch] = useReducer(
    personalDataReducer,
    initialPersonalData,
  )

  const [, shopDispatch] = useReducer(shopReducer, initialShop)

  useEffect(() => {
    if (!applicationId || applicationId === 'undefined') {
      return
    } else {
      applicationDispatch({
        action: ApplicationReducerActions.GET,
        applicationId: applicationId,
      })
    }
  }, [applicationId])

  useEffect(() => {
    const shop = props.payForm?.application?.shopCode
    if (shop) {
      shopDispatch({
        shop,
      })
    }
  }, [props.payForm?.application?.shopCode])

  useEffect(() => {
    if (
      props.payForm.application?.userId &&
      props.payForm.paymentGateway?.paymentGatewayId
    ) {
      personalDataDispatch({
        userId: props.payForm.application?.userId,
        paymentGatewayId: props.payForm.paymentGateway?.paymentGatewayId,
      })
    }
  }, [
    props.payForm.application?.userId,
    props.payForm.paymentGateway?.paymentGatewayId,
  ])

  const dispatch = useDispatch<Dispatch>()
  const paymentGateways = useSelector(
    (state: RootState) => state.paymentGateways?.paymentGateways,
  )
  useInit(async () => {
    if (!applicationId || applicationId === 'undefined') {
      return
    } else if (!paymentGateways) {
      await Promise.all([
        dispatch.paymentGateways.fetchPaymentGateways(applicationId),
      ])
    }
  })
  const selectedGateway = useSelector(
    (state: RootState) => state.payForm?.paymentGateway,
  )
  useEffect(() => {
    if (
      paymentGateways &&
      props.payForm.application?.shopCode &&
      !selectedGateway
    ) {
      const gw = paymentGateways.find(
        (value) => value.shopCode === props.payForm.application?.shopCode,
      )
      if (!gw) return
      dispatch.payForm.set({
        paymentGateway: gw,
      })
    }
  }, [props.payForm.application?.shopCode, paymentGateways])
  useEffect(() => {
    if (selectedGateway) {
      payFormService.initFormGw(selectedGateway)
    }
  }, [selectedGateway])

  return (
    <>
      <Outlet />
    </>
  )
}

export interface TShopState {
  fetched: boolean
}

export interface ShopReducerAction {
  shop: EShop
}

export const shopReducer = (state: TShopState, action: ShopReducerAction) => {
  if (!state.fetched) {
    shopApplicationClient
      .shopInfo(action.shop)
      .then((res) => payFormService.initShopInfo(res))
    return { fetched: true }
  }
  return state
}

const mapStateToProps = (state: RootState): StateProps => ({
  payForm: state.payForm,
})

export default connect(mapStateToProps)(ShopWrapperPage)
